export const RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS =
	'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';
